import defineComponent from 'flight';
import FormSelectUI from 'static/script/app/ui/form-select-ui';

function ShopItemSettingsModalDiscount() {
    this.defaultAttrs({
        discountSelect: '[data-form-select-select]',
        discountPrice: '[data-discount-price]',
        removeButton: '[data-shop-item-settings-discount-remove-button]',
        itemId: null,
        priceBeforeDiscount: null,
        discountRate: null,
        discountCount: null,
        maxDiscountCount: null
    });

    this._discountChanged = function() {
        let discountRate = this._getSelectedDiscountRate();
        let discountPrice = this._calculateDiscount(discountRate);
        if (!this._discountIsValid(discountRate, discountPrice)) {
            return;
        }
        this._setDiscountPrice(discountPrice);
        this._setDiscountStyle(discountRate > 0);
        this._updateDiscountCount();

        if (this._selectInit) {
            this._selectInit = false;
        } else {
            this._gaEvent = {};
            this._gaEvent.category = 'Shop Item Settings';
            this._gaEvent.action =
                'Discount ' + (discountRate > 0 ? 'enabled' : 'disabled');
            this._gaEvent.label = 'Discount rate: ' + discountRate;
        }
    };

    this._discountIsValid = function(discountRate, discountPrice) {
        let hasDiscount = discountRate > 0;
        return !hasDiscount || discountPrice < this.attr.priceBeforeDiscount;
    };

    this._getSelectedDiscountRate = function() {
        let selected = this.select('discountSelect').find(':selected');
        let discountRate = parseInt(selected.first().attr('value'));
        return discountRate;
    };

    this._setDiscountPrice = function(discountPrice) {
        this.select('discountPrice').html(discountPrice + ' kr');
    };

    this._setDiscountStyle = function(hasDiscount) {
        if (hasDiscount) {
            this.$node.addClass('discount');
        } else {
            this.$node.removeClass('discount');
        }
    };

    this._calculateDiscount = function(discountRate) {
        let price = Math.round(
            this.attr.priceBeforeDiscount * (1 - discountRate / 100.0)
        );
        if (price < 1) {
            return 1;
        }
        return price;
    };

    this._save = function(evt, data) {
        let discountRate = this._getSelectedDiscountRate();
        let discountPrice = this._calculateDiscount(discountRate);
        if (!this._discountIsValid(discountRate, discountPrice)) {
            discountRate = this.attr.discountRate;
        }

        data.discountRate = discountRate;

        if (!this._discountHasChanged(discountRate)) {
            return;
        }

        this.trigger(document, 'ui:shop-item-settings:discount-changed', {
            itemId: this.attr.itemId,
            discountRate: discountRate,
            discountPrice: discountPrice,
            hasDiscount: discountRate > 0
        });

        if (this._gaEvent) {
            this.trigger(document, 'analytics:track-event', this._gaEvent);
        }
    };

    this._discountHasChanged = function(discountRate) {
        return discountRate !== this.attr.discountRate;
    };

    this._close = function() {
        this.teardown();
    };

    this._initForm = function() {
        let discountRate = this.attr.discountRate;
        if (!discountRate) {
            discountRate = 0;
        }
        this.select('discountSelect').val(discountRate);
        this.select('discountSelect').change();
    };

    this._removeClicked = function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.select('discountSelect').val(0);
        this.select('discountSelect').change();
    };

    this._setDiscountLeft = function(discountLeft) {
        this.$node.find('[data-discount-left]').html(discountLeft);
    };

    this._setMaxDiscountCount = function(maxDiscountCount) {
        this.$node.find('[data-max-discount-count]').html(maxDiscountCount);
    };

    this._updateDiscountCount = function() {
        let originalDiscountCount = this.attr.discountCount;
        let originallyDiscounted = this.attr.discountRate > 0;
        let hasDiscountNow = this._getSelectedDiscountRate() > 0;
        let newCount = originalDiscountCount;

        if (originallyDiscounted && !hasDiscountNow) {
            newCount--;
        } else if (!originallyDiscounted && hasDiscountNow) {
            newCount++;
        }

        if (newCount < 0) {
            newCount = 0;
        }

        this._setDiscountLeft(this.attr.maxDiscountCount - newCount);
    };

    this._disableSelectIfNoDiscountsLeft = function() {
        let discountLeft = this.attr.maxDiscountCount - this.attr.discountCount;
        let hasDiscount = this.attr.discountRate > 0;
        if (!hasDiscount && discountLeft === 0) {
            this.select('discountSelect').prop('disabled', true);
        }
    };

    this.after('initialize', function() {
        this._selectInit = true;
        this._gaEvent = null;
        this.on('change', {
            discountSelect: this._discountChanged
        });
        this.on('click', {
            removeButton: this._removeClicked
        });
        this.on(document, 'ui:shop-item-settings-modal:save', this._save);
        this.on(document, 'ui:body-container:on-modal-close', this._close);

        this._setDiscountLeft(
            this.attr.maxDiscountCount - this.attr.discountCount
        );
        this._setMaxDiscountCount(this.attr.maxDiscountCount);
        this._disableSelectIfNoDiscountsLeft();

        FormSelectUI.attachTo('[data-form-select]');
        this._initForm();
    });

    this.around('teardown', function() {
        this.off(document, 'ui:shop-item-settings-modal:save', this._save);
        this.off(document, 'ui:body-container:on-modal-close', this._close);
    });
}

export default defineComponent.component(ShopItemSettingsModalDiscount);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/shop-item-settings-modal-discount.js